import { useCallback, useMemo, useState } from 'react';

import Box from 'shared_DEPRECATED/components/Box';
import useEventsSubscription from 'shared_DEPRECATED/hooks/useEventsSubscription';

import { Modal, SIZES, ModalProvider, modal } from 'shared/components/Modal';
import {
  MODAL_OPEN_EVENT,
  MODAL_CLOSE_EVENT,
} from 'shared/components/Modal/eventPublishers';

const initialContent = null;
const initialProps = {
  size: SIZES.SM,
  title: '',
};
const initialContext = {};

export const ModalContainer = () => {
  const [open, setOpen] = useState(false);

  const [content, setContent] = useState(initialContent);
  const [modalProps, setModalProps] = useState(initialProps);
  const [context, setContext] = useState(initialContext);

  const handleOpen = useCallback(
    (event: CustomEvent) => {
      const { content, props, context: newContext } = event.detail;

      setContent(content);
      setModalProps(Object.assign(initialProps, props || {}));
      setContext(Object.assign(initialContext, newContext || {}));

      setOpen(true);
    },
    [setOpen]
  );

  const events = useMemo(
    () => [
      [MODAL_OPEN_EVENT, handleOpen] as [string, Function],
      [MODAL_CLOSE_EVENT, () => setOpen(false)] as [string, Function],
    ],
    [handleOpen, setOpen]
  );

  useEventsSubscription(events);

  return (
    <ModalProvider {...context}>
      <Box title={modalProps.title}>
        <Modal
          {...modalProps}
          open={open}
          onInteractOutside={modal.close}
          onEscapeKeyDown={modal.close}
        >
          {content}
        </Modal>
      </Box>
    </ModalProvider>
  );
};
